import {
  createModule,
  action,
  mutation,
} from 'vuex-class-component';
import { RepositoryFactory } from '@/repository/factory/repositoryFactory';
import { SignInResponse } from '@/@types/Auth';

const VuexModule = createModule({
  namespaced: 'theoryApiAuthStore',
  strict: false,
});

export class AuthStore extends VuexModule {
  private readonly authRepository = RepositoryFactory.theoryApi.authRepository();
  /** state */
  private currentUserInfo: SignInResponse | null = null;
  private currentOrganizationId: number | null = null;
  private currentOrganizationName: string | null = null;
  private currentProjectId: number | null = null;
  private currentProjectName: string | null = null;
  /**カレント組織に紐づく全プロジェクトのID配列 */
  private currentProjectIds: number[] | null = null;

  @mutation
  private setCurrentUserInfo(payload: SignInResponse | null) {
    this.currentUserInfo = payload;
  }

  @mutation
  private setCurrentOrganizationId(payload: number | null) {
    this.currentOrganizationId = payload;
  }

  @mutation
  private setOrganizationName(payload: string | null) {
    this.currentOrganizationName = payload;
  }

  @mutation
  private setCurrentProjectId(payload: number | null) {
    this.currentProjectId = payload;
  }

  @mutation
  private setCurrentProjectName(payload: string | null) {
    this.currentProjectName = payload;
  }

  @mutation
  private setCurrentProjectIds(payload: number[] | null) {
    this.currentProjectIds = payload;
  }

  /** ログインユーザー情報取得 */
  @action
  async fetchCurrentUserInfo() {
    const userInfo = await this.authRepository.signIn();
    this.setCurrentUserInfo(userInfo);
  }

  @action
  async fetchCurrentOrganizationId(organizationId: number | null) {
    this.setCurrentOrganizationId(organizationId);
  }

  @action
  async fetchCurrentOrganizationName(organizationName: string | null) {
    this.setOrganizationName(organizationName);
  }

  @action
  async fetchCurrentProjectId(projectId: number | null) {
    this.setCurrentProjectId(projectId);
  }

  @action
  async fetchCurrentProjectName(projectName: string | null) {
    this.setCurrentProjectName(projectName);
  }

  @action
  async deleteCurrentUserInfo() {
    this.setCurrentUserInfo(null);
  }

  @action
  async fetchCurrentProjectIds(projectIds: number[] | null) {
    this.setCurrentProjectIds(projectIds);
  }

  get getCurrentUserInfo() {
    return this.currentUserInfo;
  }

  get getCurrentOrganizationId() {
    return this.currentOrganizationId;
  }

  get getCurrentOrganizationName() {
    return this.currentOrganizationName;
  }

  get getCurrentProjectId() {
    return this.currentProjectId;
  }

  /**ヘッダー用 */
  get getCurrentProjectName() {
    return this.currentProjectName;
  }

  get getCurrentProjectIds() {
    return this.currentProjectIds;
  }
}
